export default {
  'button.add': 'Add',
  'button.edit': 'Edit',
  'button.delete': 'Delete',
  'button.search': 'Search',
  'button.reset': 'Reset',
  'button.close': 'Close',
  'button.back': 'Back',
  'button.submit': 'Submit',
  'button.resetPassword': 'Reset Password',
  'button.assignRole': 'Assign Role',
  'button.dataScope': 'Data Scope',
  'button.normal': 'Normal',
  'button.disabled': 'Disabled',
  'button.enable': 'Enable',
  'button.directory': 'Directory',
  'button.menu': 'Menu',
  'button.button': 'Button',
  'button.no': 'No',
  'button.yes': 'Yes',
  'button.bindGoogle': 'Bind Google',
  'button.unbindGoogle': 'Unbind Google',
  'button.success': 'Success',
  'button.error': 'Error',
  'button.detail': 'Detail',
  'button.logout': 'Logout',
  'button.generateCode': 'Generate Code',
  'button.clearData': 'Clear Data',
  'button.other': 'Other',
  'button.onJob': 'On Job',
  'button.offJob': 'Off Job',
  'button.futures': 'Futures',
  'button.spot': 'Spot',
  'button.spotAndFutures': 'Spot and Futures',
  'button.commission': 'Participate',
  'button.noCommission': 'Not Participate',
  'button.proportion': 'Proportion',
  'button.difference': 'Difference',
  'button.partner': 'Partner',
  'button.unverified': 'Unverified',
  'button.realName': 'Real Name',
  'button.idCard': 'ID Card or Passport',
  'button.video': 'Video',
  'button.viewInviteChain': 'View Invite Chain',
  'button.deleteGa': 'Delete GA',
  'button.all': 'All',
  'button.selfCommission': 'Self Commission',
  'button.level': 'Level',
  'button.person': 'Person',
  'button.copy': 'Copy',
  'button.copyInviteLink': 'Copy Invite Link',
  'button.today': 'Today',
  'button.yesterday': 'Yesterday',
  'button.lastWeek': 'Last 7 Days',
  'button.last30Days': 'Last 30 Days',
  'button.thisMonth': 'This Month',
  'button.lastMonth': 'Last Month',
  'button.last3Months': 'Last 3 Months',
  'button.last6Months': 'Last 6 Months',
  'button.last12Months': 'Last 12 Months',
  'button.chainRecharge': 'Chain Recharge',
  'button.chainWithdraw': 'On-chain Withdrawal',
  'button.withdrawInternalTransfer': 'Internal Transfer',
  'button.withdrawUCard': 'U-Card Withdrawal',
  'button.uCardWithdraw': 'U-Card Withdrawal',
  'button.directTransfer': 'Direct Transfer',
  'button.level2': 'Level',
  'button.unsettled': 'Unsettled',
  'button.settled': 'Settled',
  'button.addPartner': 'Add Partner',
  'button.confirmNoCommission': 'Confirm No Commission',
  'button.openLong': 'Buy',
  'button.openShort': 'Sell',
  'button.fullPosition': 'Full',
  'button.marginPosition': 'Margin',
  'button.month': 'Month',
  'button.thisWeek': 'This Week',
  'button.last15Days': 'Last 15 Days',
  'button.view': 'View',
  'button.viewDetail': 'View Detail',
  'button.customInviteCode': 'Custom Invite Code',
  'button.export': 'Export',
  'button.confirm': 'Confirm',
  'button.cancel': 'Cancel',
  'button.cancelPartner': 'Cancel',
  'button.updatePartner': 'Edit Partner',
  'button.upgradePartner': 'Upgrade',
  'button.import': 'Import',
};
